import axios from 'axios';
import React, { useEffect } from 'react'
import { BASE_URL } from '../../../insightConfig/insightConfig';

const IGPClasses = () => {
    const [classes, setClasses] = React.useState([]);
    useEffect(() => {
        axios.get(BASE_URL + '/igp/getIGPClasses').then((response) => {
            console.log(response.data);
            setClasses(response.data.data);
        }
        ).catch((error) => {
            console.error("There was an error fetching the data!", error);
        });
    }, []);

    return (
        <div className='mx-'>
            <div className='History-container-box'>
                <div className='card History-card container'>
                    {/* Course Table Start */}
                    <table className="table" border="1">
                        <thead>
                            <tr className='text-center'>
                                <th colSpan="4" className='History1-course-heading table-border'>CLASSES FOR INTERVIEW GUIDANCE PROGRAM</th>
                            </tr>
                        </thead>
                        <thead >
                            <tr >
                                <th className='History2-course-heading table-border'>S.No.</th>
                                <th className='History2-course-heading table-border'>Subjects/Topics</th>
                                <th className='History2-course-heading table-border'>No. of sessions</th>
                                <th className='History2-course-heading table-border'>Downloads</th>
                            </tr>
                        </thead>
                        <tbody>
                            {classes?.map((course, index) => (
                                <tr key={index}>
                                    <td className='table-border'>{index + 1}</td>
                                    <td className='table-border table-data2'>{course.Subjects}</td>
                                    <td className='table-border table-data2 text-center'>{course.SessionCount}</td>
                                    <td className='table-border d-flex justify-content-center align-items-center '>
                                        <button className=' btn btn-sm fw-bold px-4 btn-danger' onClick={() => window.open(course.Downloads)}>Click</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/* Course Table End */}
                </div>
            </div>



        </div>
    )
}

export default IGPClasses